import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { OauthServiceType, useAccountExistenceQuery } from '@websky/graphql';
import { useAuthenticate } from '@features/auth';
import { captureErrorSentry } from '../../utils';
import { prevSocialAuthKeyFactory } from '../../SocialAuth/components/utils';
import { sessionStorageGet } from '../../cache';
import { getParsedParams, parseErrorHandler } from '../utils';
import PromoLoader from '../../PromoLoader';
import { FirstLoginAgreementModal } from '../../LoginPage';
const SocialAuthCallback = ({ socialAuthCallbackUrl }) => {
    const location = useLocation();
    const [authenticate, { loading }] = useAuthenticate();
    const { refetch: checkAccountExistence } = useAccountExistenceQuery({ skip: true });
    const [checking, setChecking] = useState(false);
    const [parsedParams, setParsedParams] = useState(null);
    const [showFirstLoginAgreement, setShowFirstLoginAgreement] = useState(false);
    const auth = (params, loginType) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield authenticate({
                variables: {
                    params: {
                        loginType,
                        secureCode: JSON.stringify(params)
                    }
                }
            });
        }
        finally {
            const prevKey = prevSocialAuthKeyFactory(OauthServiceType[loginType]);
            const prevUrl = sessionStorageGet(prevKey);
            if (prevUrl) {
                window.location.href = prevUrl;
            }
            else {
                parseErrorHandler('Social auth callback url has not been found in the session storage');
            }
        }
    });
    const handleContinueAuth = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!parsedParams) {
            return;
        }
        setShowFirstLoginAgreement(false);
        yield auth(parsedParams.params, parsedParams.loginType);
    });
    useEffect(() => {
        let alive = true;
        const run = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const parsed = getParsedParams(location.pathname, socialAuthCallbackUrl);
                if (!parsed) {
                    parseErrorHandler('Social auth parse url params error');
                    return;
                }
                setParsedParams(parsed);
                setChecking(true);
                const { data } = yield checkAccountExistence({
                    params: {
                        loginType: parsed.loginType,
                        login: JSON.stringify(parsed.params)
                    }
                });
                if ((_a = data === null || data === void 0 ? void 0 : data.AccountExistence) === null || _a === void 0 ? void 0 : _a.result) {
                    yield auth(parsed.params, parsed.loginType);
                    return;
                }
                if (alive) {
                    setShowFirstLoginAgreement(true);
                }
            }
            catch (e) {
                captureErrorSentry('Social auth account existence error');
            }
            finally {
                if (alive) {
                    setChecking(false);
                }
            }
        });
        run();
        return () => {
            alive = false;
        };
    }, []);
    if (loading || checking) {
        return React.createElement(PromoLoader, null);
    }
    return showFirstLoginAgreement ? (React.createElement(FirstLoginAgreementModal, { modalProps: {
            isOpen: showFirstLoginAgreement
        }, firstLoginAgreementProps: {
            onConfirm: handleContinueAuth
        } })) : null;
};
export default SocialAuthCallback;
